// src/component/ImageUploader.js
import React, { useState, useEffect } from "react";
import { Upload, Button } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";

const ImageUploader = ({ selectedImage, setSelectedImage, error, setError }) => {
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (selectedImage) {
            const objectUrl = URL.createObjectURL(selectedImage);
            setPreview(objectUrl);

            return () => URL.revokeObjectURL(objectUrl); 
        }
    }, [selectedImage]);

    const handleImageChange = (file) => {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

        if (!allowedTypes.includes(file.type)) {
            setError("Only JPEG, JPG, and PNG files are allowed.");
            return false;
        }

        if (file.size > 1048576) {
            setError("File size should not exceed 1MB.");
            return false;
        }

        setError("");
        setSelectedImage(file);
        return false;
    };

    const handleRemoveImage = () => {
        setSelectedImage(null);
        setPreview(null);
    };

    return (
        <div className="mt-6">
            <div className="border-dashed border-2 border-gray-300 rounded p-4 text-center">
                <p className="text-sm text-gray-500 mb-2">Attach Image</p>
                <Upload beforeUpload={handleImageChange} showUploadList={false}>
                    <Button icon={<PlusOutlined />} className="border-none text-[#db3647]">
                        Add Image
                    </Button>
                </Upload>
                {selectedImage && preview && (
                    <div className="mt-4 relative">
                        <img
                            src={preview}
                            alt="Uploaded"
                            className="w-[360px] h-28 object-cover rounded border border-gray-300"
                        />
                        <button
                            onClick={handleRemoveImage}
                            className="absolute top-0 right-0 bg-[#db3647] px-2 py-1 rounded-full text-white text-[14px]"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                )}
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default ImageUploader;
